import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import {
  //Avatar,
  //Button,
  //CssBaseline,
  //TextField,
  //Grid,
  //Box,
  //Typography,
  Container,
  //InputAdornment,
  //IconButton,
  //Link
} from '@material-ui/core';

//import { LockOutlined, Visibility, VisibilityOff } from '@material-ui/icons';

//import { makeStyles } from "@material-ui/core/styles";

//import { i18n } from "../../translate/i18n";

import { AuthContext } from "../../context/Auth/AuthContext";

// const Copyright = () => {
// 	return (
// 		<Typography variant="body2" color="textSecondary" align="center">
// 			{"Copyleft "}
// 			<Link color="inherit" href="https://github.com/canove">
// 				Canove
// 			</Link>{" "}
// 			{new Date().getFullYear()}
// 			{"."}
// 		</Typography>
// 	);
// };

/*const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));*/

const Login = () => {
  const params = useParams();
  const { handleLogin } = useContext(AuthContext);
  // const { handleLogout } = useContext(AuthContext);

  // Dispara o login UMA vez no mount. Chamar handleLogin no corpo do
  // componente (como antes) o re-invocava a cada re-render disparado pelos
  // setState do próprio handleLogin — gerava login duplicado e deixava a tela
  // de tickets em branco até o F5. Em useEffect roda só uma vez.
  useEffect(() => {
    const { email, senha, tela, id } = params;
    if (email && senha) {
      handleLogin({ email, password: senha, tela, id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <></>
    </Container>
  );
};

export default Login;
